import urlBuilder from "app/umbraco/helpers/urlBuilder";

export default (src?: string): string => {
    if (!src) {
        return "";
    }

    const fileUrl = urlBuilder(src);
    const params = new URLSearchParams();

    const querySeparator = fileUrl.toString().indexOf("?") > 0 ? "&" : "?";
    return `${fileUrl}${querySeparator}${params.toString()}`;
};
